import { Component, OnInit } from '@angular/core';
import { IonSelect, ModalController } from '@ionic/angular';
import { AdminServiceService } from '../../service/admin-service.service';
import { environment } from 'src/environments/environment';
import { ModalShopsComponent } from '../modal-shops/modal-shops.component';
import { UiService } from '../../service/ui.service';
import { ToastService } from 'src/app/generales/services/toast.service';
@Component({
  selector: 'app-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.scss'],
})
export class ShopsComponent implements OnInit {
  shops: any;
  pag = 1;
  pagSyze = 10;
  search = 'todos';
  date = 'mas-recientes';
  state = '';
  lastPage: number;
  total: number;
  url: string = environment.url;
  status = [
    {
      state: 'Activar',
      value: 0
    },
    {
      state: 'Eliminar',
      value: 1
    },
    {
      state: 'Inactivar Parcial',
      value: 2
    },
    {
      state: 'Inactivar',
      value: 3
    },
  ]

  constructor(
    private req: AdminServiceService,
    private modalCtrl: ModalController,
    private uiSv: UiService,
    private toastSv: ToastService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  async loadData() {
    this.req.getShops(this.pag, this.pagSyze, this.search, this.date, this.state).subscribe((res: any) => {
      this.shops = res.data.data;
      console.log(this.shops);
      this.lastPage = res.data.meta.last_page;
      this.total = res.data.meta.total;
    });
  }

  async buscar(event: any) {
    this.search = event.target.value;
    const code = event.keyCode || event.which;
    // const pag = 1;
    // const pagSyze = 10;
    // const date = 'mas-recientes';
    // const state = '';
    if (code === 13 && this.search.length > 2) {
      this.loadData();
    }
  }
  async changePag(i) {
    if(i){
      this.pag = this.pag + 1;
    }else{
      if(this.pag === 1){
        return;
      }
      this.pag = this.pag - 1;
    }
    this.loadData();
  }

  async disableStore(ev, shop, ionSelect: IonSelect){
    const name = shop.business_name;
    const value = ev.detail.value;
    if(value === null) return false;
    const msg = this.status.find(x => x.value === value).state;
    const { role } = await this.uiSv.presentAlert(`Deseas ${msg}: ${name}`, '');
    const body: any = {
      id: shop.id,
      isDelete: value
    };

    if(role === 'accept'){
      this.req.deleteLocation(body, 'store', 'delete').subscribe(async (res: any) => {
        await this.toastSv.show(`${name} ${msg} exitosamente`);
      })
    }else{
      ionSelect.value = null;
      ev.detail.value = null;
    }

    // if(role === 'accept'){
      // if(check){
      //   body.isDelete = 0;
      //   this.req.deleteLocation(body, 'store', 'delete').subscribe((res: any) => {
      //     if(res.status){
      //       this.toastSv.show(`${name} habilitado exitosamente`);
      //       checkbox.checked = !checkbox.checked;
      //     }
      //   }, err => {
      //     console.error(err);
      //   })
      // }else{
      //   body.isDelete = 1;
      //   this.req.deleteLocation(body, 'store', 'delete').subscribe((res: any) => {
      //     if(res.status){
      //       this.toastSv.show(`${name} deshabilitado exitosamente`);
      //       checkbox.checked = !checkbox.checked;
      //     }
      //   }, err => {
      //     console.error(err);
      //   })
      // }
    // }else{
    //   checkbox.checked = !check;
    // }
  }

  async goShop(i) {
    const modal = await this.modalCtrl.create({
      component: ModalShopsComponent,
      cssClass: 'modal-blog-comentarios',
      componentProps: {shop: i},
    });

    modal.present();
  }
}
